import React from 'react'
import { Spinner } from 'react-bootstrap'
import Message from './Message'
import '../styles/modals.css'

function ExportDashboardModal({ closeCallback, onExportJson, onExportPdf, pdfDisabled, busy, error }) {
  return (
    <div className='modal-container'>
      <div style={{ maxWidth: '360px', borderRadius: '8px' }} className='modal-window p-4'>
        <div className='d-flex justify-content-between align-items-center mb-3'>
          <h5 className='m-0 fw-bold'>Export Dashboard</h5>
          <i onClick={() => closeCallback()} style={{ cursor: 'pointer' }} className='fa-solid fa-xmark text-secondary'></i>
        </div>

        <p className='p-paragraph text-black'>Choose a format to export this dashboard.</p>

        {error && <Message variant='danger'>{error}</Message>}

        {busy ? (
          <div className='d-flex justify-content-center align-items-center py-3'>
            <Spinner animation='border' as={'span'} style={{ width: '20px', height: '20px' }} />
          </div>
        ) : (
          <div className='d-flex flex-column gap-2'>
            <button onClick={onExportJson} type='button' className='btn btn-dark text-white text-start'>
              <i className='fa-solid fa-file-code pe-2'></i>
              Export as JSON
              <div className='p-paragraph m-0' style={{ fontSize: '12px', color: 'rgba(255,255,255,0.75)' }}>
                Portable data — for backups, testing copies, or sharing with colleagues.
              </div>
            </button>

            <button
              onClick={pdfDisabled ? undefined : onExportPdf}
              type='button'
              disabled={pdfDisabled}
              className='btn btn-outline-dark text-start'
            >
              <i className='fa-solid fa-file-pdf pe-2'></i>
              Export as PDF
              <div className='p-paragraph m-0' style={{ fontSize: '12px', color: '#8b8b8b' }}>
                {pdfDisabled
                  ? 'Switch to Lecture Mode first — PDF export captures the read-only view.'
                  : 'A print-ready snapshot of the dashboard as you currently see it.'}
              </div>
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default ExportDashboardModal
